import React, {useEffect}  from "react";
import {isMobile} from 'react-device-detect';
import {Home} from '../components/Template/Desktop/Lighttheme';
import {HomeMobile} from '../components/Template/Mobile';
import HeadSEO from "../components/Head";

function ServerMobileComponent({ serverData }){
    return(
      <HomeMobile serverData={serverData}/>
    )
  }
  function ServerPCComponent({ serverData }){
    return(
      <Home  serverData={serverData}/>
    )
  }
export default function Index({serverData}) {

   useEffect(()=>{
      if(window.localStorage.getItem('_id') && window.localStorage.getItem('_id') !== ''){
        window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ ecommerce: null });
            window.dataLayer.push({
                    'event': 'login',
                    'user_id': window.localStorage.getItem('_id'),
                    'eventCallback': function() {
                    }
                });
      }
    },[]);

  return (
    <>
    {
        isMobile === false ?(<ServerPCComponent  serverData={serverData}/>):(
        <>
        <ServerMobileComponent serverData={serverData}/>
        </>
        )
    }
     <h1 className="d-none">Bibo Mart - Hệ thống siêu thị Mẹ và Bé</h1>
        <div className="description d-none">
        <p>Hệ thống siêu thị Mẹ và Bé Bibo Mart chuyên cung cấp đồ cho mẹ bầu, đồ sơ sinh, tã sữa, đồ chơi, xe đẩy, giường cũi, sản phẩm dành riêng cho mẹ bé giá tốt và chia sẻ những kiến thức hữu ích nhất.</p>
      </div>
      <div className="zalo-chat-widget" data-oaid="360706546542426311" data-welcome-message="Xin chào. Bibo Mart Rất vui khi được hỗ trợ bạn!" data-autopopup="0" data-width="" data-height=""></div>
    </>
  )
}
export function Head(serverData) {
  return (
    <>
    <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/css/bootstrap.min.css" rel="stylesheet" /> 
    <link rel="stylesheet" href="/static/css/Lighttheme.min.css" type="text/css" /> 
    {/* <link rel="stylesheet" href="/static/css/Lighttheme.css" type="text/css" />  */}
    <link rel="stylesheet" href="/../static/css/style_app.min.css" type="text/css" />
    {/* <link rel="stylesheet" href="/../static/css/style_app.css" type="text/css" /> */}
    <link rel="stylesheet" href="/static/css/categories.min.css" type="text/css" />
    <HeadSEO key="Head" item={serverData.serverData?.Title}/>
    </>
  )
}
export async function getServerData() {
  let Title = {
    "meta_title": "Bibo Mart - Hệ thống siêu thị Mẹ và Bé",
    "meta_keyword": "bibomart, bibo mart, bibo, shop mẹ và bé, cửa hàng mẹ bé, đồ sơ sinh, đồ cho mẹ bầu, bà bầu",
    "meta_description": "Hệ thống siêu thị Mẹ và Bé Bibo Mart chuyên cung cấp đồ cho mẹ bầu, đồ sơ sinh, tã sữa, đồ chơi, xe đẩy, giường cũi, sản phẩm dành riêng cho mẹ bé giá tốt và chia sẻ những kiến thức hữu ích nhất.",
    "meta_url": "",
    "meta_site": "",
    "meta_img":"",
    "url_key":"trang-chu"
};
 let DataSlider = {};
  const res = await fetch('https://prod.bibomart.net/campaign360/Banner/get_banner?MaManHinh=M003-1', 
  {
      headers: {
          'Authorization': 'Bearer yuiFbyemq8tYxUoBKo2_plELGG3eB9cNqF6DkGC8n67LC6mwOe7ynhI+QtqKuvGJlZY'
      }
  })
  if (res.ok) {
    DataSlider = await res.json();
  }


  let DataSliderPC = {};
  const resPC = await fetch('https://prod.bibomart.net/campaign360/Banner/get_banner_app?MaViTri=B003T01', 
  {
      headers: {
          'Authorization': 'Bearer yuiFbyemq8tYxUoBKo2_plELGG3eB9cNqF6DkGC8n67LC6mwOe7ynhI+QtqKuvGJlZY'
      }
  })
  if (resPC.ok) {
    DataSliderPC = await resPC.json();
  }

  // let DataCategory = {};
  // const resCate = await fetch('https://customerapp.bibomart.net/api/mobile/web/menu/div')
  // if (resCate.ok) {
  //   DataCategory = await resCate.json();
  // }

  try {
    return {
      props: {Title, DataSlider, DataSliderPC}
}
} catch (error) {
  return {
    status: 500,
    headers: {},
    props: {}
  }
}
}